import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=848ef660&scoped=true&"
import script from "./PaymentModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaymentModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848ef660",
  null
  
)

export default component.exports